import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import { Navigate, NavLink } from 'react-router-dom'

import style from '@src/pages/Registration/Registration.module.scss'
import { Title } from '@src/components/Title/Title'
import { Button } from '@src/components/Button/Button'
import { AppDispatch } from '@src/store/store'
import { resetAuth } from '@src/store/ducks/auth/reducer'
// import { RegistrationForm } from '@src/pages/Registration/RegistrationForm'
import { selectIsAuth } from '@src/store/ducks/app/selectors'

export const Registration = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isAuth = useSelector(selectIsAuth)

  useEffect(() => () => {
    dispatch(resetAuth())
  }, [dispatch])

  if (isAuth) {
    return <Navigate to="/lk/points/" />
  }
  return (
    <div className={cn(style.registration)}>
      <div className={style.registration__body}>
        <div className={style.tabList}>
          <NavLink end className={style.btnSize} to="/lk/login">
            <Button>Авторизация</Button>
          </NavLink>
          {/* <NavLink end className={style.btnSize} to="/lk/registration"> */}
          {/*  <Button className={cn(style.active)}>Регистрация</Button> */}
          {/* </NavLink> */}
          <NavLink end className={style.btnSize} to="/lk/activation">
            <Button>Активация</Button>
          </NavLink>
        </div>
        <div className={style.title}>
          <Title greenTitle="Регистрация" title="клиента" />
        </div>
        <div>
          {/* <RegistrationForm /> */}
        </div>
      </div>
    </div>
  )
}
